class ResponseInterceptorRequestService {
    responseInterceptors = [];
    registerInterceptor(interceptor) {
        this.responseInterceptors.unshift(interceptor);
        return ()=>{
            const index = this.responseInterceptors.indexOf(interceptor);
            if (-1 !== index) this.responseInterceptors.splice(index, 1);
        };
    }
    removeInterceptor(responseInterceptorClass) {
        this.responseInterceptors = this.responseInterceptors.filter((responseInterceptor)=>!(responseInterceptor instanceof responseInterceptorClass));
    }
    clearInterceptors() {
        this.responseInterceptors = [];
    }
    intercept(fetchRequest) {
        return this.responseInterceptors.reduce((currentPromise, { onSuccess, onError })=>currentPromise.then(onSuccess).catch(onError), fetchRequest);
    }
}
export { ResponseInterceptorRequestService };
